import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=633030b8"
import script from "./AvatarUploader.vue?vue&type=script&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports